import { FC, ReactNode } from 'react';
import { styled, Tooltip, TooltipProps } from '@mui/material';
import classNames from 'classnames';

import { Icon, IconOption, IconProps } from './Icon';

export type HintProps = Pick<TooltipProps, 'id'> &
  Pick<IconProps, 'color' | 'warning'> & {
    icon: IconOption;
    soft?: boolean;
    tooltip: ReactNode;
  };

const StyledIcon = styled(Icon)`
  border-radius: 99px;
  cursor: help;

  &:focus {
    outline: 0;
  }

  &.soft {
    &:focus-visible,
    &:hover {
      color: ${({ theme }) => theme.palette.action.active};
    }
  }
`;

export const Hint: FC<HintProps> = ({ color, icon, id, soft, tooltip, warning }) => (
  <Tooltip id={id} title={tooltip}>
    <StyledIcon
      className={classNames({ soft })}
      color={color ?? (soft ? 'disabled' : undefined)}
      fontSize='small'
      name={icon}
      tabIndex={0}
      warning={warning}
    />
  </Tooltip>
);

Hint.displayName = 'Hint';
